import { AxiosResponse } from 'axios';

/**Standard Avamae Endpoint Response**/
export interface ApiResponse<T> {
    details: T;
    status: '1' | '0';
    errors: any;
  }

  /* Shared */

  export interface Response<T> {
    data: T | null;
    error: { message: string | null | undefined; formErrors?: FormError[]; fieldName?: string } | null;
  }

  export type FormError = {fieldName: string; messageCode: string};

  export class BaseApi {
    public static isResponseSuccessful = (response: ApiResponse<any>) =>
      response.status === '1';

    public static successResponse = function <T>(data: T): Response<T> {
      return {
        data,
        error: null,
      };
    };

    public static errorResponse = (message: string, errors?: FormError[], fieldName?: string): Response<null> => {
      return {
        data: null,
        error: {
          message,
          formErrors: errors,
          fieldName: fieldName
        },
      };
    };

    public static send = async function <T>(
      request: () => Promise<AxiosResponse<ApiResponse<T>>>,
      parseError: (errors?: FormError[] | null) => string
    ): Promise<Response<T>> {
      try {
        const result = await request();
        if (BaseApi.isResponseSuccessful(result.data)) {
          return BaseApi.successResponse(result.data.details);
        }
        return BaseApi.errorResponse(parseError(result.data.errors), result.data.errors);
      } catch (error: any) {
        const errors = error?.response?.data?.errors;
        return BaseApi.errorResponse(parseError(errors), errors);
      }
    };
  }
